import { Group, Text } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useEffect } from "react";
import Button from "../../components/Button";
import DescriptionField from "../../components/descriptionField";
import InputField from "../../components/inputField";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { alphaNumericRegex, descriptionRegex } from "../../constants/index";
import { addAndEditData } from "../generalPostAndEditData";

export const AddIndustryType = ({
  opened,
  setOpened,
  setUpdate,
  editData,
  setEditData,
  editModalState,
  setEditModalState,
  setLoading,
}) => {
  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      typeName: "",
      typeDescription: "",
    },

    validate: {
      typeName: (value) =>
        value?.trim()?.length > 1 && alphaNumericRegex.test(value.trim())
          ? null
          : "Alphabetic Name with 2 or more characters",
      typeDescription: (value) =>
        value?.trim()?.length > 20 && descriptionRegex.test(value.trim())
          ? null
          : "Description with 20 or more characters",
    },
  });
  useEffect(() => {
    if (editModalState) {
      form.setFieldValue("typeName", editData.typeName);
      form.setFieldValue("typeDescription", editData.typeDescription);
    }
  }, [opened]);

  const onSubmit = (values) => {
    let url = "";
    if (editModalState) {
      values.industryTypeId = editData._id;
      url = "industryType/editIndustryType";
      setEditData({});
      setEditModalState(false);
    } else {
      url = "industryType/addIndustryType";
    }
    form.reset();
    setLoading(true);
    addAndEditData(values, setOpened, setUpdate, url);
  };
  const InternalContent = (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Text mb={0} weight={500}>
        Industry Type Name
      </Text>
      <InputField
        width="100%"
        placeholder="Enter Industry Type Name"
        form={form}
        validateName="typeName"
      />

      <Text mt="md" mb={0} weight={500}>
        Description
      </Text>
      <DescriptionField
        maxRows={4}
        minRows={3}
        autosize={true}
        width="100%"
        placeholder="Enter Type Description"
        form={form}
        validateName="typeDescription"
      />

      <Group position="right" pt="xl">
        <Button
          title={"Clear"}
          fontWeight="700"
          onClick={() => {
            form.reset();
          }}
        />
        <Button
          title={editModalState ? "Update" : "Add"}
          primary={true}
          fontWeight="700"
          type="submit"
        />
      </Group>
    </form>
  );
  return (
    <ModalWrapper
      opened={opened}
      setOpened={setOpened}
      InternalComponent={InternalContent}
      title={editModalState ? "Edit Industry Type" : "Add Industry Type"}
      form={form}
      setEditData={setEditData}
      setEditModalState={setEditModalState}
      addEdit={true}
    />
  );
};
